var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-nocheck
import { Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import TCardPreview from '../TCardPreview';
import TCardContext, { ACTIONS } from '../TCardContext';
import TCardForm from '../TCardForm';
import VisaIcon from '@dev-togetherprice/icons.visa';
import WhiteLogoIcon from '@dev-togetherprice/icons.white-logo';
import { Money } from '@dev-togetherprice/monetary';
import Carousel from '@dev-togetherprice/components.carousel';
import { useWalletBalance } from '@dev-togetherprice/api.financial';
import { getRecaptcha, isRecaptchaEnabled } from '@dev-togetherprice/api.captcha';
import MasterCard from '@dev-togetherprice/icons.master-card';
const useStyles = makeStyles((theme) => ({
    cardWrapper: { flexWrap: 'nowrap', alignItems: 'center' },
    visa: {
        width: 52,
        height: 16,
    },
    mastercard: {
        width: 50,
        height: 40,
    },
    logo: {
        width: 32,
        height: 32,
    },
    modify: {
        marginLeft: 'auto',
        textDecoration: 'underline',
        paddingRight: theme.spacing(2),
        cursor: 'pointer',
    },
    add: {},
}));
const TCardPreviewList = ({ card }) => {
    const { data: wallet } = useWalletBalance();
    const { state: { showWallet, t, showCardForm, captchaToken, captcha, onError, onSelect, }, dispatch, } = useContext(TCardContext);
    const [step, setStep] = useState(0);
    const Steps = [
        'CARD',
        showWallet && wallet.availableBalance.value > 0 ? 'WALLET' : false,
    ].filter(Boolean);
    const classes = useStyles();
    const selectPaymentType = (type, forceSave) => __awaiter(void 0, void 0, void 0, function* () {
        if (type === 'CARD' && showCardForm && !forceSave)
            return onSelect('');
        if (!captchaToken && !forceSave) {
            const captchaRes = yield getRecaptcha(captcha === null || captcha === void 0 ? void 0 : captcha.current).catch((error) => {
                var _a;
                const message = ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message) || t('error', { error: JSON.stringify(error) });
                onError(message);
                console.error(error);
                return null;
            });
            if (!captchaRes ||
                (captchaRes === null || captchaRes === void 0 ? void 0 : captchaRes.status) !== 'SUCCESS' ||
                !(captchaRes === null || captchaRes === void 0 ? void 0 : captchaRes.token)) {
                return false;
            }
            dispatch({
                type: ACTIONS.SET_CAPTCHA_TOKEN,
                payload: captchaRes.token,
            });
        }
        dispatch({ type: ACTIONS.SELECT_PAYMENT_TYPE, payload: type });
        onSelect(Object.assign({ type }, (type === 'WALLET' ? { balance: wallet.availableBalance.value } : {})));
    });
    useEffect(() => {
        isRecaptchaEnabled();
        if (captcha.current) {
            selectPaymentType(Steps[0]);
        }
        return () => { };
    }, [captcha.current]);
    return (React.createElement(Carousel, { onStepChange: (currentStep) => {
            setStep(currentStep);
            selectPaymentType(Steps[currentStep]);
        } },
        React.createElement(Grid, { className: classes.cardWrapper, container: true, direction: 'column' },
            !showCardForm && (React.createElement(Typography, { className: classes.modify, onClick: () => dispatch({ type: ACTIONS.SHOW_CARD_FORM, payload: true }), variant: 'body2', color: 'textSecondary' }, t('modify'))),
            showCardForm ? (React.createElement(TCardForm, { onSave: () => {
                    selectPaymentType(Steps[step], true);
                } })) : (React.createElement(TCardPreview, { name: 'CARD', icon: (card === null || card === void 0 ? void 0 : card.brand) === 'mastercard' ? (React.createElement(MasterCard, { className: classes.mastercard })) : (React.createElement(VisaIcon, { className: classes.visa })), description: {
                    text: t('cardNumber'),
                    body: t('cardPlaceholder', { last4: card === null || card === void 0 ? void 0 : card.last4 }),
                }, subDescription: `${card === null || card === void 0 ? void 0 : card.expMonth}/${card === null || card === void 0 ? void 0 : card.expYear}` }))),
        showWallet && wallet.availableBalance.value > 0 && (React.createElement(TCardPreview, { name: 'WALLET', text: t('wallet.title'), icon: React.createElement(WhiteLogoIcon, { className: classes.logo }), description: {
                text: t('wallet.description'),
            }, subDescription: Money.toString(wallet.availableBalance) }))));
};
export default TCardPreviewList;
